import React from "react";
import "./confirmation.scss";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { AiOutlineClose } from "react-icons/ai"; // Cross icon from react-icons

const ReasonPopup = ({
  openDeleteModal,
  handleCloseDeleteConfirmationModal,
  isLoading,
  selectedReason,
  setSelectedReason,
  onadminupdate,
}) => {
  return (
    <Dialog open={openDeleteModal} onClose={handleCloseDeleteConfirmationModal}>
      <DialogTitle id="alert-dialog-title" sx={{ m: 0, p: 2 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <p id="warining-message"></p>
          <span
            onClick={handleCloseDeleteConfirmationModal}
            style={{
              cursor: "pointer",
              fontSize: "20px",
              color: "#999",
            }}
          >
            <AiOutlineClose />
          </span>
        </div>
      </DialogTitle>

      <DialogContent>
        <div className="reason_section">
          <div className="Label_name_details">
            <label>Approval Reason</label>
            <select
              name="refer_code"
              className="input_field_pgmdetails"
              value={selectedReason}
              onChange={(e) => setSelectedReason(e.target.value)}
            >
              <option value="">Select Reason</option>
              <option value="verified_as_pgm">Verified as PGM</option>
              <option value="verified_as_retailer">Verified as Retailer</option>
            </select>
          </div>
        </div>
      </DialogContent>

      <DialogActions>
        <Button
          id="button-no"
          onClick={handleCloseDeleteConfirmationModal}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          id="button-yes"
          onClick={onadminupdate}
          disabled={!selectedReason || isLoading}
        >
          {isLoading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReasonPopup;
